// Counts how many ancestors an element has; deeper = more nested, used to pick the innermost shortcut scope.
export const getDomDepth = (el: HTMLElement | null): number => {
  let depth = 0;
  let current: HTMLElement | null = el;
  while (current) {
    depth += 1;
    current = current.parentElement;
  }
  return depth;
};
